import { useMemo } from 'react';

import BaseCheckbox from '@r1-frontend/ui-react/components/controls/baseCheckbox';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { bonusPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';

import * as ST from './styled';

export interface IBonusesPaymentProps {
    availableBonuses: number,
    value: string | number,
    maxLength: string,
    isChecked: boolean,
    isDisabled: boolean,
    isValid: boolean,
    onToggle: () => void,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void,
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void,
}

/**
 * Форма для оплаты бонусами
 */
export const BonusesPaymentForm = ({
    availableBonuses,
    value,
    maxLength,
    isChecked,
    isDisabled,
    isValid,
    onToggle,
    onChange,
    onFocus,
    onBlur,
}: IBonusesPaymentProps): JSX.Element => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.mobile);
    const isAbnProgramTermsEnabled = useMemo(getIsAbnLoyaltyProgramEnabled, []);

    return (
        <ST.Wrapper>
            <BaseCheckbox
                size={isTablet ? 'XS' : 'S'}
                checked={isChecked}
                disabled={isDisabled}
                onChange={onToggle}
            >
                <ST.Label>
                    <ST.Text>
                        Списать бонусы ({isAbnProgramTermsEnabled
                            ? <>100 бонусов = 20 {RubleSymbol}</>
                            : <>1 бонус = 1 {RubleSymbol}</>
                        })
                    </ST.Text>
                    <ST.Info
                        isValid={isValid}
                        data-test='loyalty-info'
                    >
                        У вас {availableBonuses} {pluralize(availableBonuses, bonusPluralize)}
                    </ST.Info>
                </ST.Label>
            </BaseCheckbox>
            <ST.InputBonuses
                inputType={'text'}
                value={value}
                maxLength={maxLength}
                onFocus={onFocus}
                onChange={onChange}
                onBlur={onBlur}
                isNotValid={!isValid}
                disabled={!isChecked || isDisabled}
                required={isChecked}
                data-test='loyalty-input'
            />
        </ST.Wrapper>
    );
};
